'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AxisTop;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Axis = require('./Axis');

var _Axis2 = _interopRequireDefault(_Axis);

var _orientation = require('../constants/orientation');

var _orientation2 = _interopRequireDefault(_orientation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AxisTop(_ref) {
  var scale = _ref.scale,
      top = _ref.top,
      left = _ref.left,
      stroke = _ref.stroke,
      strokeWidth = _ref.strokeWidth,
      strokeDasharray = _ref.strokeDasharray,
      rangePadding = _ref.rangePadding,
      label = _ref.label,
      _ref$labelOffset = _ref.labelOffset,
      labelOffset = _ref$labelOffset === undefined ? 8 : _ref$labelOffset,
      numTicks = _ref.numTicks,
      tickFormat = _ref.tickFormat,
      tickStroke = _ref.tickStroke,
      tickTransform = _ref.tickTransform,
      tickValues = _ref.tickValues,
      _ref$tickLength = _ref.tickLength,
      tickLength = _ref$tickLength === undefined ? 8 : _ref$tickLength,
      _ref$tickLabelCompone = _ref.tickLabelComponent,
      tickLabelComponent = _ref$tickLabelCompone === undefined ? _react2.default.createElement('text', {
    textAnchor: 'middle',
    fontFamily: 'Arial',
    fontSize: 10,
    fill: 'black',
    dy: '-0.25em'
  }) : _ref$tickLabelCompone,
      hideAxisLine = _ref.hideAxisLine,
      hideTicks = _ref.hideTicks,
      hideZero = _ref.hideZero,
      className = _ref.className;

  return _react2.default.createElement(_Axis2.default, {
    className: (0, _classnames2.default)('vx-axis-top', className),
    orientation: _orientation2.default.top,
    top: top,
    left: left,
    scale: scale,
    stroke: stroke,
    strokeWidth: strokeWidth,
    strokeDasharray: strokeDasharray,
    rangePadding: rangePadding,
    labelComponent: typeof label === 'string' ? _react2.default.createElement(
      'text',
      {
        textAnchor: 'middle',
        fontFamily: 'Arial',
        fontSize: 10,
        fill: 'black'
      },
      label
    ) : label,
    numTicks: numTicks,
    tickFormat: tickFormat,
    tickLength: tickLength,
    tickTransform: tickTransform,
    tickStroke: tickStroke,
    tickValues: tickValues,
    labelOffset: labelOffset,
    tickLabelComponent: tickLabelComponent,
    hideAxisLine: hideAxisLine,
    hideTicks: hideTicks,
    hideZero: hideZero
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/@vx/axis/build/axis/AxisTop.js
// module id = ./node_modules/@vx/axis/build/axis/AxisTop.js
// module chunks = 2345137460201621000 9249036036638527000 16304781003358073000